interface Props {
  children: React.ReactNode;
}

export const Container = ({ children }: Props) => {
  return (
    <div className="mx-auto box-border w-full max-w-[theme(screens.2xl)] px-8">
      {children}
    </div>
  );
};
